<div class="main_container">
    <h1 style="color: green">Cargar Reportes</h1>

    <!-- Selección de año -->
    <div class="year_card">
        <h2>Selecciona un año</h2>
        <div class="year_input" (click)="abrirModalAnio()">
            {{ anioSeleccionado || 'Selecciona un año' }}
        </div>
    </div>

    <!-- Cards de reportes -->
    <ng-container *ngFor="let reporte of reportes">
        <div
            class="report_card"
            *appPermiso="'ver_y_cargar_reporte_' + reporte.id + '_madr'">
            <div class="report_info">
                <h2>{{ reporte.titulo }}</h2>
                <p>
                    {{ reporte.descripcion }}
                </p>
                <!-- Muestra el archivo seleccionado -->
                <small *ngIf="reporte.archivo">
                    Archivo seleccionado:
                    {{ reporte.archivo.name }}
                </small>
            </div>

            <div>
                <input
                    #fileInput
                    type="file"
                    hidden
                    accept=".xlsx,.xls"
                    (change)="seleccionarArchivo($event, reporte.id)" />
                <button
                    type="button"
                    (click)="openUploadModal(modalLoadReport, reporte)">
                    Cargar
                </button>
            </div>
        </div>
    </ng-container>

    <!-- Guardar -->
    <div class="actions">
        <button type="button" class="save_button" (click)="saveReportes()">
            Guardar
            <span
                *ngIf="cantidadReportesSeleccionados > 0"
                class="reportes_count">
                {{ cantidadReportesSeleccionados }}
            </span>
        </button>
    </div>
</div>

<!-- Modal selección de año -->
<div *ngIf="mostrarModalAnio" class="modal_overlay">
    <div class="modal_anio">
        <div class="modal_header">
            <h2>Seleccionar año</h2>
            <button
                type="button"
                class="close_button"
                (click)="cerrarModalAnio()">
                ×
            </button>
        </div>
        <div class="modal_content">
            <label for="anioModal">Año:</label>
            <select id="anioModal" [(ngModel)]="anioTemporal">
                <option [ngValue]="null" disabled>Selecciona un año</option>
                <option *ngFor="let anio of anios" [ngValue]="anio">
                    {{ anio }}
                </option>
            </select>
        </div>
        <div class="modal_footer">
            <button
                type="button"
                class="continue_button"
                (click)="continuarAnio()"
                [disabled]="!anioTemporal">
                Continuar
            </button>
        </div>
    </div>
</div>

<ng-template #modalLoadReport>
    <div class="modal-content">
        <div class="modal-header border-0">
            <h5 class="modal-title">Carga de reportes</h5>
            <button type="button" class="close" (click)="closeUploadModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div
            class="modal-body border-0 d-flex align-items-center justify-content-center">
            <div class="row">
                <div class="col title-file">
                    <p>{{ 'reporte.cargaMADR' | translate }}</p>
                </div>
                <div class="row container-file">
                    <label for="fileInput" style="width: 100%; cursor: pointer">
                        <div class="col" *ngIf="!selectedFile">
                            <div class="container text-center">
                                <h5>Carga el archivo</h5>
                                <p class="text-muted">.xlsx- Max 2 Mb</p>
                                <input
                                    type="file"
                                    id="fileInput"
                                    style="display: none"
                                    (change)="onFileSelected($event)" />
                            </div>
                        </div>
                    </label>
                    <div class="col text-center">
                        <div *ngIf="selectedFile" class="text-center">
                            <p>{{ selectedFile.name }}</p>
                            <p>{{ getFileSize(selectedFile.size) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer border-0 justify-content-center">
            <button
                type="button"
                class="btn btn-success"
                (click)="saveUpload()"
                [disabled]="!selectedFile">
                {{ reporteYaTieneArchivo ? 'Reemplazar' : 'Guardar' }}
            </button>
        </div>
    </div>
</ng-template>
